





























import type { PropType } from "vue"
import type { stadium_business_stock } from "@/@types/stadium/stadium"
import { Vue } from "vue-property-decorator"
import moment from "moment"

export default Vue.extend({
  name: "StadiumBusinessForm",
  props: {
    id      : { type: String, required: true },
    button  : { type: Boolean, default: true },
    editable: { type: Boolean, required: true },
    form    : { type: Object as PropType<stadium_business_stock> }
  },
  data() {
    return {
      times : [
        {
          start: null as moment.Moment | null,
          end  : null as moment.Moment | null,
          days : [] as string[]
        }
      ],
      days: [
        { label: "周一", value: "1" },
        { label: "周二", value: "2" },
        { label: "周三", value: "3" },
        { label: "周四", value: "4" },
        { label: "周五", value: "5" },
        { label: "周六", value: "6" },
        { label: "周日", value: "0" },
      ],
      rules: {
        business_time: { required: true, message: "请完善营业时间", trigger: "blur" },
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        if (this.form.business_time && this.form.business_time.length > 0) {
          this.times = []
          for (const time of this.form.business_time) {
            const temp = time.split(",")
            const t    = temp[0].split("-")
            delete temp[0]
            this.times.push({ start: moment(t[0], "HH:mm"), end: moment(t[1], "HH:mm"), days: temp })
          }
        }
      })
    },
    add_time() {
      this.times.push({
        start: null as moment.Moment | null,
        end  : null as moment.Moment | null,
        days : []
      })
    },
    submit() {
      const times = []
      for (const v of this.times) {
        if (v.start && v.end) {
          const temp = `${v.start.format("HH:mm")}-${v.end.format("HH:mm")}`
          const item = [temp].concat(v.days).join(",")
          times.push(item)
        }
      }
      const params = this.$deep_copy(this.form)
      params.estimate_id = this.id
      params.business_time = times.join(";")
      this.$emit("save", params)
    },
    check(): boolean {
      let checked = false
      const form = this.$refs.form as any
      form.validate((valid: boolean) => {
        checked = valid
      })
      return checked
    },
  }
})

